import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from './global.service';
import { Subject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./global.service";
import * as i3 from "ngx-cookie-service";
var API_CHANGE_PASSWORD = '/employeePublic/profile/change-password';
/**
 * EmployeeService (ptnw-3.0-productivity)
 *
 * REVISI 2026-09-07: file ini sebelumnya berisi salinan lengkap ~90 method HTTP
 * (family /employee/hrd/*, /employeeAdmin/dev/*, /movement/*, /productivity/*, dll),
 * TIDAK SATU PUN dipanggil di repo ini kecuali `changePassword()` (dikonfirmasi via
 * grep menyeluruh -- pemakaian lain EmployeeService di repo ini cuma properti
 * `mobileToggleEmit` di subheader.component.ts). Dihapus sekalian saat audit path
 * module Employee/PettyCash pasca-split (ticket #845 lanjutan), method
 * `changePassword()` yang live DIPERTAHANKAN apa adanya (sudah benar, path
 * employeePublic/profile/change-password) -- lihat plan doc ptnw-3.0-docs
 * brainstorms/2026-09-03-authorization2-rbac-pettycash-plan.md §9.6.
 */
var EmployeeService = /** @class */ (function () {
    function EmployeeService(http, globalService, cookieService) {
        this.http = http;
        this.globalService = globalService;
        this.cookieService = cookieService;
        this.mobileToggleEmit = new Subject();
        this.mobileToggleEmitObs = this.mobileToggleEmit.asObservable();
        this.loadBankAccountEmit = new Subject();
        this.loadBankAccountEmitObs = this.loadBankAccountEmit.asObservable();
        this.mobileToggleEmit.next(false);
        this.loadBankAccountEmit.next(false);
    }
    EmployeeService.prototype.header = function (module) {
        if (module === void 0) { module = 'employee'; }
        return {
            headers: new HttpHeaders()
                .set('token', this.cookieService.get('_q'))
                .set('module', localStorage.getItem(module))
                .set('group', this.cookieService.get('_g'))
        };
    };
    EmployeeService.prototype.changePassword = function (param) {
        return this.http.post(this.globalService.apiVersionHost + API_CHANGE_PASSWORD, param, this.header('employeePublic'));
    };
    EmployeeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EmployeeService_Factory() { return new EmployeeService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.GlobalService), i0.ɵɵinject(i3.CookieService)); }, token: EmployeeService, providedIn: "root" });
    return EmployeeService;
}());
export { EmployeeService };
